import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { IntervaloParcelasRequest, Response } from './Types';

class IntervaloParcelasController {
  public static async Adicionar(
    request: IntervaloParcelasRequest
  ): Promise<Response> {
    try {
      console.log('Controller IntervaloParcelas Adicionar');
      console.log(request);

      const response = await Api.post(
        `api/intervaloparcelas/Adicionar`,
        request
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(
    request: IntervaloParcelasRequest
  ): Promise<Response> {
    try {
      console.log('Controller IntervaloParcelas Excluir');
      console.log(request);

      const response = await Api.put(`api/intervaloparcelas/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default IntervaloParcelasController;
